<template>
    <div
        class="toTop"
        :style="{ backgroundColor: 'rgba(255, 255, 255, ' + opacity + ')' }"
        :class="{ toTopHide: toTopHide }"
        @touchstart.prevent="toTop"
    ></div>
</template>

<script>
export default {
    props: {
        //用ref无法识别
        listId: {
            type: String,
            required: true,
        },
        opacity: {
            type: [Number, String],
            default: 1
        },
    },
    data() {
        return {
            touchstartY: 0,
            touchendY: 0,
            toTopHide: true,
            listDom: {},
        };
    },
    mounted() {
        this.$nextTick(() => {
            this.listDom = document.getElementById(this.listId);
            // this.listDom.addEventListener("touchstart", e => {
            //     this.touchstartY = e.touches[0].pageY;
            // });

            // this.listDom.addEventListener("touchmove", e => {
            //     this.touchendY = e.touches[0].pageY;
            // });

            this.listDom.addEventListener("scroll", e => {
                if (this.listDom.scrollTop < 200) {
                    this.toTopHide = true;
                }else if(this.listDom.scrollTop > 200) {
                    this.toTopHide = false
                }
            });
        });
    },
    methods: {
        toTop() {
            // console.log('toTop');
            // setTimeout(()=>{
            //     this.listDom.scrollTop = 0;
            // })
            let nowScrollTop = this.listDom.scrollTop;
            let timer = setInterval(() => {
                if (this.listDom.scrollTop > 0) {
                    this.listDom.scrollTop -= 0.06 * nowScrollTop;
                } else {
                    clearInterval(timer);
                    this.toTopHide = true;
                }
            }, 16);
        },
    },
    // computed: {
    //     touchdif() {
    //         let touchdif = this.touchendY - this.touchstartY;
    //         if (Math.abs(touchdif) > 20) {
    //             return touchdif;
    //         } else {
    //             return 0;
    //         }
    //     },
    // },
    // watch: {
    //     touchdif(newV) {
    //         if (this.listDom.scrollTop > 200) {
    //             if (newV < 0) {
    //                 this.toTopHide = true;
    //             } else if (newV > 0) {
    //                 this.toTopHide = false;
    //             }
    //         } else {
    //             return;
    //         }
    //     },
    // },
};
</script>

<style scoped>
.toTop {
    bottom: 18vw;
    right: 6vw;
    width: 12vw;
    height: 12vw;
    border-radius: 50%;
    position: fixed;
    z-index: 9;
    box-shadow: 0 0 4px 3px rgba(138, 138, 138, 0.2);
    transform: translateX(0);
    opacity: 1;
    transition: all 0.4s ease;
}
.toTop::after {
    margin: 50% auto;
    transform: translateY(-40%);
    display: block;
    content: "";
    width: calc(0.45 * 10vw);
    height: calc(0.45 * 10vw);
    background-image: url("../assets/img/toTop.png");
    background-size: cover;
    background-position: center;
}
.toTopHide {
    opacity: 0;
    transform: translateX(20vw);
    transition: all 0.4s ease;
}
</style>
